export const appendQueryToUri = (uri, json) => {
  for (var prop in json) {
    if (json[prop] == null) {
      delete json[prop];
    }
  }
  return `${uri}?${new URLSearchParams(json).toString()}`;
};

// export function groupBy(arr,groupArg){
//     let result = {}
//     arr.forEach(m => {
//         if(!result[m[groupArg]]) result[m[groupArg]] = [];
//         result[m[groupArg]].push(m);
//     })
//     return result;
// }

export function getRandomValue(min, max) {
  const randomDecimal = Math.random();
  const randomValue = randomDecimal * (max - min) + min;
  const roundedValue = Math.round(randomValue);
  return roundedValue;
}

export const debounce = (callback, delay) => {
  let timerId;

  return (...args) => {
    clearTimeout(timerId);

    timerId = setTimeout(() => {
      callback(...args);
    }, delay);
  };
};

export const getQueryParam = (param) => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(param);
};

export const getRootPath = () => {
  const pathname = window.location.pathname;
  const regex = /^\/([^\/]+)/;
  const match = pathname.match(regex);
  var subscriber = match ? match[1] : null;
  return subscriber;
};

export function isValidValue(value) {
  return value !== null && value !== undefined && value !== "";
}

export function groupBy(arr, keyFn) {
  return arr.reduce((result, item) => {
    const key = keyFn(item);
    if (!result[key]) {
      result[key] = [];
    }
    result[key].push(item);
    return result;
  }, {});
}

export const getSize = (size) => {
  let sizeMb = (size / (1024 * 1024)).toFixed(1);

  console.log("sizeMb", sizeMb);

  if (parseFloat(sizeMb) <= 0) {
    return (size / 1024).toFixed(1) + " KB";
  }

  return sizeMb + " MB";
};

export const buildEditData = (postData, editData) => {
  let ref = postData;
  let count = 1;
  let prop = "";
  while (true) {
    prop = editData[`ID_ROOT_${count}`];

    //check if next exist
    if (typeof editData[`ID_ROOT_${count + 1}`] == "undefined") break;

    ref[prop] = typeof ref[prop] != "undefined" ? ref[prop] : {};
    ref = ref[prop];

    count++;
  }

  ref[prop] = ref[prop] ? [].concat(ref[prop], editData[prop]) : editData[prop];
  return postData;
};

// export function encodeHTML(str) {
//   const div = document.createElement('div');
//   div.textContent = str;
//   return div.innerHTML;
// }

// export function decodeHTML(str) {
//   const div = document.createElement('div');
//   div.innerHTML = str;
//   return div.textContent;
// }

export function encodeHTML(str) {
  return encodeURIComponent(str);
}

export function decodeHTML(str) {
  if (typeof str !== "string") return "";

  try {
    return decodeURIComponent(str);
  } catch {
    return str; // fallback to original
  }
}
